/**
 * --------------------------------------------------------------------------
 * Ace (v3.1.0): index.js
 * --------------------------------------------------------------------------
 */

import Util from './util'
import Basic from './general'
import Scrollbar from './scrollbar'
import Sidebar from './sidebar'
import Aside from './aside'
import Toaster from './toaster'
import Widget from './widget'
import FileInput from './fileinput'
import Wysiwyg from './wysiwyg'
import { NavTabScroller, NavLinkScroller } from './tab-scroll'
import TabSwipe from './tab-swipe'
import ScrollTop from './scroll-top'
import Sticky from './sticky'

export default {
  Util,
  Basic,
  Scrollbar,
  Sidebar,
  Aside,
  Toaster,
  Widget,
  FileInput,
  Wysiwyg,
  NavTabScroller,
  NavLinkScroller,
  TabSwipe,
  ScrollTop,
  Sticky
}
